<template>
  <div>
    <div class="address_box">
      <div class="h2">
        地址管理 <span> 已保存了{{total}}条地址，还能保存{{20-total}}条地址！</span>
      </div>
      <ul style="width:1028px;margin:0 auto;" class="clearfix_">
        <li v-for="(item,index) in addressList" :key="index" class="address_item fl">
          <div class="clearfix_ txt1">
            <span @click="changeDefaultAddress(item.id)" class="fl home_"></span>
            <span v-show="item.status==1" class="fl" style="color:#dd2a3c;">默认地址</span>
            <span class="fr">
              <span @click="deleteAddress(item.id)" class="fl _delete_"></span>
              <span @click="modifyAddress(item.id)" class="fl modify_"></span>
            </span>
          </div>
          <div class="clearfix_ txt2">
            <span class="fl name">{{item.consignee}}</span>
            <span class="fl mobilePhone">{{item.mobilePhone}}</span>
          </div>
          <div class="txt3">{{item.areaText}}</div>
          <div class="txt4">{{item.address}}</div>
        </li>
        <li v-show="total<20" @click="openNewAddress" class="fl add_address">
          <p>增加新地址</p>
        </li>
      </ul>
    </div>
    <div v-show="isBlockMask" class="address_mask">
      <div class="addNewAddress">
        <h2>{{isModify?'修改收货地址':'新增收货地址'}}<span @click="offAddNewAddress">×</span></h2>
        <div class="addNewAddress_content">
          <ul>
            <li>
              <i class="fl"><span> * </span>收货人：</i>
              <input v-model="consignee" class="addNewAddress_content_input fl">
            </li>
            <li>
              <i class="fl">座机：</i>
              <input v-model="landline" class="addNewAddress_content_input fl">
            </li>
            <li>
              <i class="fl"><span> * </span>联系电话：</i>
              <input v-model="mobilePhone" class="addNewAddress_content_input fl" @blur="telvalidation" ref="tel">
              <em class="fl tips" v-if="isTips">{{tips}}</em>
            </li>
            <li>
              <i class="fl">邮政编码：</i>
              <input v-model="zipCode" class="addNewAddress_content_input fl">
            </li>
            <li class="clearfix_">
              <i class="fl"><span> * </span>所在地：</i>
              <ul class="level_ fl clearfix_">
                <li class="fl">
                  <p @click="boxShow(0)">{{provinceTxt}}</p>
                  <ul class="child" v-show="idx_0">
                    <li @click="choiceProvince(item.name,item.id)" v-for="(item,index) in provinceList" :key="index">{{item.name}}</li>
                  </ul>
                </li>
                <li class="fl">
                  <p @click="boxShow(1)">{{cityTxt}}</p>
                  <ul class="child" v-show="idx_1">
                    <li @click="choiceCity(item.name,item.id)" v-for="(item,index) in cityList" :key="index">{{item.name}}</li>
                  </ul>
                </li>
                <li class="fl">
                  <p @click="boxShow(2)">{{countyTxt}}</p>
                  <ul class="child" v-show="idx_2">
                    <li @click="choiceCounty(item.name,item.id)" v-for="(item,index) in countyList" :key="index">{{item.name}}</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li style="height:80px;">
              <i class="fl"><span> * </span>详细地址：</i>
              <textarea maxlength="50" v-model="detailedAddress" class="addNewAddress_content_input fl addNewAddress_content_textarea"></textarea>
            </li>
            <li>
              <i class="fl"><span> * </span>是否默认：</i>
              <el-switch class="radio_" @change="changeDefault" v-model="isDefault" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </li>
          </ul>
          <div style="text-align:center;">
            <button @click="submit" :disabled="disablestyle" :style="{background:bggray,color:fontcolor,cursor:shustyle}" class="addNewAddress_content_btn">{{isModify?'修改地址':'保存地址'}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  inject:['reload'],
  data(){
    return {
      tips:'',
      isTips:false,
      isDefault:true,
      consignee:'',
      landline:'',
      mobilePhone:'',
      zipCode:'',
      detailedAddress:'',
      disablestyle:'',
      bggray:'',
      fontcolor:'',
      shustyle:'',
      provinceTxt:'--请选择--',
      provinceList:[],
      provinceId:'',
      cityTxt:'--请选择--',
      cityList:[],
      cityId:'',
      countyTxt:'--请选择--',
      countyList:[],
      countyId:'',
      addressList:[],
      isBlockMask:false,
      idx_0:false,
      idx_1:false,
      idx_2:false,
      addressObj:{},
      isModify:false,
      newAddressId:'',
      total:0
    }
  },
  computed:{
    formdata () {
      const {consignee,mobilePhone,detailedAddress,provinceTxt,cityTxt,countyTxt} = this;
      this.$nextTick(() => {
      })
      return {
        consignee,mobilePhone,detailedAddress,provinceTxt,cityTxt,countyTxt
      }
    }
  },
  watch:{
    formdata:{
      handler: function(val) {
        if(val.consignee!= ""&& val.mobilePhone!=""&&val.detailedAddress!=""&&val.provinceTxt!='--请选择--'&&val.cityTxt!=='--请选择--'&&val.countyTxt!='--请选择--'){
          this.bggray = "#FFAA00";
          this.fontcolor = "white";
          this.disablestyle = false;
          this.shustyle = "pointer"
        }else {
          this.bggray = "gray";
          this.fontcolor = "white";
          this.disablestyle = "disabled";
          this.shustyle = "not-allowed"
        }
      },
      deep: true
    }
  },
  mounted:function(){
    var t_=this
    t_.getArea(0,0)
    t_.getAddress()
  },
  methods:{
    changeDefaultAddress:function(id){
      var t_=this
      var data=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        addressId:id,
        channel:2
      })
      axios.post(`${ip}formWorkInterface/AddressDefault`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:'设置默认地址成功',
            center:true,
            type:'success'
          })
          t_.reload()
        }else{
          t_.$message({
            message:'设置默认地址失败，请稍后再试。',
            center:true,
            type:'warning'
          })
        }
      })
    },
    modifyAddress:function(id){
      var t_=this
      var data=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        addressId:id,
        channel:2
      })
      axios.post(`${ip}formWorkInterface/getAddressById`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.newAddressId=res.data.results.id
          t_.consignee=res.data.results.consignee
          t_.provinceId=res.data.results.proId
          t_.provinceTxt=res.data.results.areaText.split(',')[0]
          t_.cityId=res.data.results.cityId
          t_.cityTxt=res.data.results.areaText.split(',')[1]
          t_.countyId=res.data.results.countyId
          t_.countyTxt=res.data.results.areaText.split(',')[2]
          t_.getArea(t_.provinceId,0)
          t_.getArea(t_.provinceId,t_.cityId)
          t_.detailedAddress=res.data.results.address
          t_.mobilePhone=res.data.results.mobilePhone
          t_.isBlockMask=true
          t_.isModify=true
        }
      })
    },
    deleteAddress:function(id){
      var t_=this
      var data=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        addressId:id,
        channel:2
      })
      axios.post(`${ip}formWorkInterface/AddressDelete`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:'删除地址成功',
            center:true,
            type:'success'
          })
          t_.reload()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    choiceProvince:function(name,id){
      var t_=this
      t_.provinceTxt=name
      t_.provinceId=id
      t_.cityTxt='--请选择--'
      t_.cityId=''
      t_.countyTxt='--请选择--'
      t_.countyId=''
      t_.getArea(t_.provinceId,0)
      t_.idx_0=false
    },
    choiceCity:function(name,id){
      var t_=this
      t_.cityTxt=name
      t_.cityId=id
      t_.countyTxt='--请选择--'
      t_.countyId=''
      t_.getArea(t_.provinceId,t_.cityId)
      t_.idx_1=false
    },
    choiceCounty:function(name,id){
      var t_=this
      t_.countyTxt=name
      t_.countyId=id
      t_.idx_2=false
    },
    getArea:function(id1,id2){
      var t_=this
      var data=Qs.stringify({
        province:id1,
        city:id2,
        tamp:localStorage.tamp?localStorage.tamp:''
      })
      axios.post(`${ip}formWorkInterface/getArea`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.status==1){
            t_.provinceList=res.data.results
          }else if(res.data.status==2){
            t_.cityList=res.data.results
          }else if(res.data.status==3){
            t_.countyList=res.data.results
          }
        }
      })
    },
    boxShow:function(idx){
      var t_=this
      if(idx==0){
        if(t_.idx_0){
          t_.idx_0=false
        }else{
          t_.idx_0=true
        }
      }else if(idx==1){
        if(t_.provinceTxt=='--请选择--')return
        if(t_.idx_1){
          t_.idx_1=false
        }else{
          t_.idx_1=true
        }
      }else if(idx==2){
        if(t_.cityTxt=='--请选择--')return
        if(t_.idx_2){
          t_.idx_2=false
        }else{
          t_.idx_2=true
        }
      }
    },
    openNewAddress:function(){
      var t_=this
      t_.isBlockMask=true
    },
    offAddNewAddress:function(){
      var t_=this
      t_.isBlockMask=false
      t_.provinceId=''
      t_.provinceTxt='--请选择--'
      t_.cityId=''
      t_.cityTxt='--请选择--'
      t_.cityList=[]
      t_.countyId=''
      t_.countyTxt='--请选择--'
      t_.countyList=[]
      t_.consignee=''
      t_.detailedAddress=''
      t_.mobilePhone=''
      t_.landline=''
      t_.zipCode=''
      t_.isModify=false
      t_.tips = ""
      t_.isTips = false;
    },
    getAddress:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:1,
        pagesize:100
      })
      axios.post(`${ip}formWorkInterface/getAddressByMemberId`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0)t_.addressList=res.data.results.rows,t_.total=res.data.results.total
      })
    },
    submit:function(){
      var t_=this
      var str=t_.provinceTxt+','+t_.cityTxt+','+t_.countyTxt
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        consignee:t_.consignee,
        mobilePhone:t_.mobilePhone,
        address:t_.detailedAddress,
        county:t_.countyId,
        areaText:str,
        status:t_.isDefault?1:2
      }
      if(t_.isModify)data0bj.addressId=t_.newAddressId
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/saveAddress`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.results.message,
            center:true,
            type:'success'
          })
          t_.reload()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    telvalidation:function () {
      if(this.mobilePhone == "" || this.mobilePhone == null){
        this.mobilePhone = "";
        this.tips = "不能为空！";
        this.isTips = true;
      }else {
        var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
        var a = this.mobilePhone;
        if (!reg.test(a)) {
          this.mobilePhone = "";
          this.isTips = true;
          this.tips = "请输入正确的联系电话！";
        }else {
          this.tips = ""
          this.isTips = false;
        }
      }
    },
    changeDefault:function(val){
      var t_=this
      t_.isDefault=val
    }
  }
}
</script>
<style>
  .address_box{
    width: 1068px;
    border: 1px solid #ddd;
    background: #fff;
    /* padding: 20px 20px 0 20px; */
  }
  .address_box .h2{
    height: 38px;
    line-height: 38px;
    font-size:16px;
    font-weight: 900;
    background: #fafafa;
    padding-left: 10px;
    margin-bottom: 25px;
  }
  .address_box .h2 span{
    font-size: 12px;
    color:#999;
    font-weight: 100;
  }
  .address_box li{
    margin: 0 16px 20px 0;
  }
  .address_item{
    width: 245px;
    height: 138px;
    background: url(../../assets/img/address_1.png);
    padding-top: 11px;
  }
  .address_box li:nth-child(4n){
    margin-right: 0;
  }
  .address_item:hover{
    background: url(../../assets/img/address_2.png);
  }
  .address_item .home_{
    width: 14px;
    height: 12px;
    background: url(../../assets/img/home.png) no-repeat center;
    margin-right: 5px;
    cursor: pointer;
  }
  .address_item .txt1{
    margin-left: 6px;
    margin-bottom: 20px;
    height: 14px;
  }
  .address_item .txt1 ._delete_{
    width: 14px;
    height: 15px;
    background: #000;
    cursor: pointer;
    display: none;
    margin-right: 8px;
    margin-top: -1px;
    background: url(../../assets/img/delete_.png);
  }
  .address_item:hover .txt1 ._delete_{
    display: block;
  }
  .address_item .txt1 .modify_{
    width: 12px;
    height: 12px;
    margin-right: 7px;
    cursor: pointer;
  }
  .address_item .txt2{
    margin-left: 22px;
    margin-bottom: 21px;
  }
  .address_item .txt2 .name{
    width: 55px;
    height: 12px;
    color:#333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .address_item .txt3,.address_item .txt4{
    margin-left: 22px;
    width: 203px;
    color:#333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }
  .address_item .txt4{
    color:#999;
  }
  .add_address{
    width: 241px;
    height: 58px;
    padding-top: 87px;
    border: 2px dashed #ddd;
    background: url(../../assets/img/add_address_2.png) no-repeat center 40px;
    cursor: pointer;
  }
  .add_address p{
    text-align: center;
    color:#bbb;
  }
  .add_address:hover{
    border: 2px dashed #dd2a3c;
    background: url(../../assets/img/add_address_1.png) no-repeat center 40px;
  }
  .add_address:hover p{
    color:#666;
  }
  .address_mask{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 777;
  }
  .addNewAddress{
    width: 600px;
    height: 445px;
    border-radius: 5px;
    background: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }
  .addNewAddress h2{
    height: 50px;
    background: #f3f3f3;
    line-height: 50px;
    text-align: center;
    color: #666;
    border-radius: 5px 5px 0 0;
  }
  .addNewAddress h2 span{
    width: 16px;
    height: 16px;
    position: absolute;
    top: 8px;
    right: 8px;
    line-height: 1;
    font-size: 20px;
    cursor: pointer;
  }
  .addNewAddress_content{
    height: 380px;
    padding-top: 15px;
  }
  .addNewAddress_content .level_ p{
    width: 98px;
    height: 24px;
    border: 1px solid #ccc;
    /* border-radius: 3px; */
    text-align: center;
    line-height: 24px;
    cursor: pointer;
  }
  .addNewAddress_content .level_>li{
    margin-right: 15px;
    position: relative;
  }
  .addNewAddress_content>ul>li{
    height: 40px;
  }
  .addNewAddress_content i{
    line-height: 40px;
    width: 100px;
    text-align: right;
    margin-right: 15px;
  }
  .addNewAddress_content i span{
    color:red;
  }
  .addNewAddress_content .level_{
    margin-top: 8px;
  }
  .addNewAddress_content_input{
    width: 172px;
    height: 24px;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin-top: 8px;
    padding-left: 8px;
  }
  .addNewAddress_content_textarea{
    width: 322px;
    height: 60px;
  }
  .radio_{
    margin-top: 10px;
  }
  .addNewAddress_content_btn{
    width: 100px;
    height: 35px;
    line-height: 35px;
    border: 0;
    border-radius: 5px;
    background: gray;
    color:#fff;
    cursor: not-allowed;;
  }
  .tips{
    line-height: 40px;
    margin-left: 15px;
    color:red;
  }
  .level_ .child{
    position: absolute;
    border: 1px solid #bbb;
    width: 98px;
    top: 25px;
    left: 0px;
    background: #fff;
    height: 150px;
    overflow-y: auto;
    z-index: 1000;
  }
  .level_ .child li{
    text-align: center;
    line-height: 26px;
    margin: 0;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/address.vue